import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-logo">
            <img src="/company-logo.png" alt="บริษัท ไทย วายเอสวาย เทรดดิ้ง จำกัด" className="navbar-logo-img" style={{maxHeight: '40px'}} />
            <h2>THAI YSY TRADING</h2>
          </div>
          
          <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li className="navbar-item">
              <Link to="/" className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}>หน้าแรก</Link>
            </li>
            <li className="navbar-item">
              <Link to="/products" className={`navbar-link ${location.pathname === '/products' ? 'active' : ''}`}>สินค้า</Link>
            </li>
            <li className="navbar-item">
              <Link to="/blog" className={`navbar-link ${location.pathname === '/blog' || location.pathname.startsWith('/blog/') ? 'active' : ''}`}>บทความ</Link>
            </li>
            <li className="navbar-item">
              <Link to="/about" className={`navbar-link ${location.pathname === '/about' ? 'active' : ''}`}>เกี่ยวกับเรา</Link>
            </li>
            <li className="navbar-item">
              <Link to="/contact" className={`navbar-link ${location.pathname === '/contact' ? 'active' : ''}`}>ติดต่อ</Link>
            </li>
          </ul>

          <button 
            className="navbar-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;